import { render, staticRenderFns } from "./configThirdPartyManagement.vue?vue&type=template&id=235c6550&"
import script from "./configThirdPartyManagement.vue?vue&type=script&lang=js&"
export * from "./configThirdPartyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports